import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface PoliciesModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PoliciesModal({
  isOpen,
  onClose
}: PoliciesModalProps) {
  return <AnimatePresence data-id="element-84">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[100]" data-id="element-85" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-[#111111] border border-neutral-800 rounded-2xl z-[101] flex flex-col overflow-hidden shadow-[0_0_60px_rgba(0,0,0,0.8)]" data-id="element-86">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-neutral-800 flex-shrink-0" data-id="element-87">
              <h2 className="text-xl font-bold text-white" data-id="element-88">
                Políticas y Condiciones
              </h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-neutral-800 transition-colors" data-id="element-89">
                <XIcon className="w-5 h-5 text-neutral-400" data-id="element-90" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto p-6 space-y-6 text-[#D1D5DB] text-sm leading-relaxed flex-1" data-id="element-91">
              <section data-id="element-92">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-93">
                  1. Información General
                </h3>
                <p data-id="element-94">
                  El producto "Tu Primer Sueldo en Dólares" es un manual digital
                  (ebook) en formato PDF de 20 páginas, creado con fines
                  educativos e informativos. Al realizar la compra, usted acepta
                  los términos y condiciones aquí descritos.
                </p>
              </section>

              <section data-id="element-95">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-96">
                  2. Producto Digital
                </h3>
                <p data-id="element-97">
                  Este es un producto 100% digital. No se realizan envíos
                  físicos. Una vez completado el pago, recibirá acceso inmediato
                  al manual y las plantillas de mensajes incluidas. El acceso es
                  de por vida y no tiene cargos recurrentes.
                </p>
              </section>

              <section data-id="element-98">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-99">
                  3. Política de Reembolso
                </h3>
                <p data-id="element-100">
                  Ofrecemos una garantía de satisfacción. Si no está conforme
                  con el producto, puede solicitar un reembolso completo dentro
                  de los 7 días posteriores a la compra enviando un correo
                  electrónico a nuestro equipo de soporte. No se requiere
                  justificación.
                </p>
              </section>

              <section data-id="element-101">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-102">
                  4. Resultados y Expectativas
                </h3>
                <p data-id="element-103">
                  Los resultados mencionados en la página de ventas son ejemplos
                  ilustrativos y no constituyen una garantía de ingresos. Los
                  resultados individuales dependen del esfuerzo, dedicación,
                  habilidades previas y condiciones del mercado de cada persona.
                  No garantizamos ingresos específicos.
                </p>
              </section>

              <section data-id="element-104">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-105">
                  5. Propiedad Intelectual
                </h3>
                <p data-id="element-106">
                  Todo el contenido del manual, incluyendo textos, plantillas,
                  estrategias y diseño, está protegido por derechos de autor.
                  Queda prohibida la reproducción, distribución o reventa total
                  o parcial del material sin autorización expresa por escrito.
                </p>
              </section>

              <section data-id="element-107">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-108">
                  6. Privacidad de Datos
                </h3>
                <p data-id="element-109">
                  Respetamos su privacidad. Los datos personales proporcionados
                  durante la compra (nombre, correo electrónico, información de
                  pago) serán utilizados exclusivamente para procesar su pedido
                  y enviar el producto. No compartimos, vendemos ni cedemos su
                  información a terceros.
                </p>
              </section>

              <section data-id="element-110">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-111">
                  7. Métodos de Pago
                </h3>
                <p data-id="element-112">
                  Aceptamos pagos a través de plataformas seguras. Todos los
                  precios están expresados en dólares estadounidenses (USD). El
                  procesamiento del pago es manejado por proveedores externos
                  certificados con encriptación SSL.
                </p>
              </section>

              <section data-id="element-113">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-114">
                  8. Limitación de Responsabilidad
                </h3>
                <p data-id="element-115">
                  Este producto no constituye asesoría financiera, legal ni
                  profesional. El contenido es meramente educativo. No nos
                  hacemos responsables por decisiones tomadas con base en la
                  información del manual. Esta página no está afiliada ni
                  respaldada por Facebook, Google, Airtm o Wise.
                </p>
              </section>

              <section data-id="element-116">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-117">
                  9. Contacto
                </h3>
                <p data-id="element-118">
                  Para cualquier consulta, solicitud de reembolso o soporte
                  técnico, puede contactarnos a través de nuestro correo
                  electrónico de soporte. Respondemos en un plazo máximo de 48
                  horas hábiles.
                </p>
              </section>

              <section data-id="element-119">
                <h3 className="text-[#C9A84C] font-bold text-base mb-2" data-id="element-120">
                  10. Aceptación de Términos
                </h3>
                <p data-id="element-121">
                  Al realizar la compra del manual "Tu Primer Sueldo en
                  Dólares", usted declara haber leído, entendido y aceptado
                  todas las políticas y condiciones aquí establecidas.
                </p>
              </section>

              <p className="text-neutral-500 text-xs pt-4 border-t border-neutral-800" data-id="element-122">
                Última actualización:{' '}
                {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
// Hook helper for easy usage
export function usePoliciesModal() {
  const [isOpen, setIsOpen] = useState(false);
  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  };
}